import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
const LoginRight = () => {
  return (
    <div>
      <div>
        <div className="flex justify-between sm:justify-end space-x-6 items-center p-3">
          <div>
            <p className="text-lg cursor-pointer font-semibold text-green-400">
              Andromeda Orginals
            </p>
          </div>
          <div>
            <p className="text-lg font-semibold cursor-pointer text-green-400">
              Community
            </p>
          </div>
          <div>
            <Link to="/login">
              <button className="px-6 py-1 text-md text-white focus:outline-none font-semibold bg-blue-600 hover:bg-blue-500">
                Login
              </button>
            </Link>
          </div>
        </div>

        <div className="mt-16 sm:mt-20 lg:ml-20">
          <div className="max-w-2xl p-3">
            <h1 className="text-5xl sm:text-7xl font-bold tracking-wide text-blue-400">
              Welcome to Virgo Cluster
            </h1>
            <p className="text-blue-200 text-lg font-bold tracking-wider ml-2 mt-4">
              Join Cluster to watch the latest movies, TV shows and
              award-winning Andromeda Originals
            </p>

            <p className="text-right mt-3 text-blue-200 text-base font-bold tracking-wider">
              4k+ people joined us now it's you'r turn
            </p>

            <h1 className="text-blue-300 text-lg font-bold tracking-wider ml-2 mt-2">
              Membership on Access
            </h1>
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between max-w-2xl lg:ml-24 mt-16 space-x-3">
            <div className="">
              <img src={logo} alt="" className=" object-contain h-20 p-2" />
            </div>
            <div>
              <img
                src="https://www.freepnglogos.com/uploads/netflix-tv-logo-png-9.png"
                alt=""
                className=" object-contain  h-12"
              />
            </div>
            <div>
              <img
                src="https://logodownload.org/wp-content/uploads/2020/11/disney-plus-logo-1.png"
                alt=""
                className=" object-contain h-20"
              />
            </div>
            <div>
              <img
                src="https://download.logo.wine/logo/Hulu/Hulu-Logo.wine.png"
                alt=""
                className=" object-contain h-20"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginRight;
